"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpCallout = HelpCallout;

var _react = _interopRequireDefault(require("react"));

var Elems = _interopRequireWildcard(require("./HelpCallout.styles"));

function HelpCallout({
  children,
  id,
  renderTrigger: Trigger
}) {
  return /*#__PURE__*/_react.default.createElement(Elems.Container, {
    "aria-hidden": true
  }, /*#__PURE__*/_react.default.createElement(Elems.Trigger, null, Trigger), /*#__PURE__*/_react.default.createElement(Elems.Content, {
    id: id,
    onClick: event => {
      event.stopPropagation();
    }
  }, children));
}